export default __webpack_public_path__ + "static/parasar-fed2d2b2efd8f824163c0c46a3007a1c.webp";